import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function getPremios(year, month, option) {
  const date = new Date();
  let day = date.getDate();
  let tmpMonth = month;

  if (day < 8 && !option) {
    tmpMonth = tmpMonth - 1;
    // if (tmpMonth === 0) {
    //   tmpMonth = 1;
    // }
  }

  const url = `${webservice}/getAutomovil?&option=${option}&usuarioOK=${getCookie(
    'usuarioOk',
  )}&year=${year}&month=${tmpMonth}`;
  let response = {};

  await superagent
    .get(url)
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      response = res?.body || {};
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
